import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceEmployeeDetailPage from "@/pages/admin/PerformanceEmployeeDetailPage";

export const Route = createFileRoute("/_admin/admin/performance/employees/$id")({
  head: () => pageHead("Admin · Performance · Employees", "AKIVA admin · performance · employees portal.", "/admin/performance/employees/$id", true),
  component: PerformanceEmployeeDetailPage,
});
